// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"museum-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.9999 3C10.5215 3 9.14647 3.44251 8 4.2023V21H16L16 4.20241C14.8535 3.44255 13.4784 3 11.9999 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M2 9C5.31371 9 8 11.6863 8 15V21H2V9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M22 9C18.6863 9 16 11.6863 16 15V21H22V9Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 21V16M16 21V15C16 11.6863 18.6863 9 22 9V21H16ZM8 21V15C8 11.6863 5.31371 9 2 9V21H8ZM12 7.99805H12.0039V8.00195H12V7.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 4.7V21H16L16 4.70011M7.00195 4.99804C7.3101 4.7047 7.64403 4.43821 8 4.2023C9.14647 3.44251 10.5215 3 11.9999 3C13.4784 3 14.8535 3.44255 16 4.20241C16.3567 4.43882 16.6913 4.70593 16.9999 4.99999","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-museum-1')
export default class Museum1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'museum-1',
    }
  }
}
